import script from "./MysticResult.vue?vue&type=script&setup=true&lang=js"
export * from "./MysticResult.vue?vue&type=script&setup=true&lang=js"

import "./MysticResult.vue?vue&type=style&index=0&id=bb19601e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-bb19601e"]])

export default __exports__